// extracted by mini-css-extract-plugin
export default {"FormGroup":"PaymentForm_FormGroup__3NFrE","buttons":"PaymentForm_buttons__qrpx+","success":"PaymentForm_success__6gelO"};